export default {
  getLanguage: function () {
    //if (locale === "zh") return "zh_CN";
    return "en_US";
  },
};
